 const Data=[
    {
        id:1,
        question:'What is UTOPIA42?',
        answer:'UTOPIA42 is blockchain’s first Proof of Knowledge (PoK) network, poise to revolutionize global education and general learning, utilizing decentralization. The title UTOPIA42 is also the platform’s native token and DEX name. '
    },
    {
        id:2,
        question:'What is a DEX?',
        answer:'It’s an acronym for decentralized exchange. Entailing a non-intermediary cryptocurrency exchange for secure peer-to-peer transactions.'
    }, {
        id:3,
        question:'What blockchain is UTOPIA42 built on?',
        answer:'UTOPIA42 and a handful of its foremost ecosystem would be primarily developed on the Binance Smart Chain. However, momentarily, there’s to be a multi-chain integration and compatibility for the UTOPIA42 token and DEX. And ultimately, a non-exclusive wholesome migration to the network’s native blockchain; AcadChain. '
    }, {
        id:4,
        question:'When is UTOPIA42 planning its launch??',
        answer:'A presale of $ACDX token scheduled for Q1 2022 in the form of an Initial DEX Offering (IDO), would be the network’s first public outing. Onwards, other planned rollouts cited on the roadmap would be duly fulfilled. '
    }, {
        id:5,
        question:'What is the $ACDX token supply?',
        answer:'The maximum supply for $ACDX would be 1,000,000,000 (One Billion) tokens, with a 0.5% quarterly burn rate. A proposed 50% of the lot would be for the public’s acquisition. '
    },
    {
        id:6,
        question:'How can one get $ACDX?',
        answer:'You can seamlessly get the $ACDX token during the presale/IDO rounds, swapping for it on eventual exchanges or by liquidity provision. '
    },
    {
        id:7,
        question:'What wallets can one use for the IDO?',
        answer:'The majority of the existing Web3 wallets would be compatible for connection and transacting during the IDO rounds.'
    },
    {
        id:8,
        question:'Is there an official socials group?',
answer:'We have an official telegram group. With other media presence on medium and twitter. '    },
]
export default Data